export default __webpack_public_path__ + "static/28_31-a601eae3847b6be044f73e8ff463e620.png";